import { useEffect, useRef } from 'react';
import { MessageBubble } from './MessageBubble';
import { Composer } from './Composer';
import { useThread } from './useThread';
import styles from './ThreadsView.module.css';

const SUGGESTIONS = [
  'Explícame este apartado',
  'Resúmemelo en 3 ideas',
  'Hazme una pregunta de examen',
  '¿Por qué es importante?'
];

type Props = {
  initialMessage?: string;
};

export function ThreadsView({ initialMessage }: Props) {
  const { messages, send, isStreaming } = useThread();
  const endRef = useRef<HTMLDivElement>(null);
  const seededRef = useRef(false);

  useEffect(() => {
    if (initialMessage && !seededRef.current) {
      seededRef.current = true;
      send(initialMessage);
    }
  }, [initialMessage, send]);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }, [messages]);

  return (
    <div className={styles.view}>
      <div className={styles.scroll}>
        {messages.length === 0 ? (
          <EmptyState />
        ) : (
          <ul className={styles.list}>
            {messages.map((m) => (
              <li key={m.id}>
                <MessageBubble msg={m} />
              </li>
            ))}
          </ul>
        )}
        <div ref={endRef} />
      </div>

      <div className={styles.footer}>
        {messages.length === 0 && (
          <div className={styles.chipsRow}>
            {SUGGESTIONS.map((s) => (
              <button
                key={s}
                type="button"
                className={styles.chip}
                onClick={() => send(s)}
                disabled={isStreaming}
              >
                {s}
              </button>
            ))}
          </div>
        )}
        <Composer onSend={send} disabled={isStreaming} />
      </div>
    </div>
  );
}

function EmptyState() {
  return (
    <div className={styles.empty}>
      <div className={styles.emptyIcon} aria-hidden>✨</div>
      <h3 className={styles.emptyTitle}>¿En qué puedo ayudarte?</h3>
      <p className={styles.emptyBody}>
        Pregúntame lo que necesites del módulo actual. Puedo explicarte conceptos,
        plantearte ejercicios o resumirte el material.
      </p>
    </div>
  );
}
